import React, { useEffect, useRef, useState } from 'react'
import { callApi } from '../../ApiHelper/ApiHelper';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { Spinner } from 'reactstrap';

export default function FaqList() {
    const [isLoading, setIsLoading] = useState(false);
    const scrollRef = useRef(null);
    const [state, setState] = useState({
        faqList: [],
        pagination: {
            currentPage: 1,
            itemsPerPage: 10,
            totalItems: 0,
            totalPages: 1,
        },
    });

    useEffect(() => {
        getFaq();
    }, [state.pagination.currentPage]);

    const getFaq = () => {
        setIsLoading(true);
        callApi(apiUrl.get_faq + `?page=${state.pagination.currentPage}&limit=5`).then((response) => {
            setIsLoading(false);
            if (response?.status) {
                setState((prev) => ({
                    ...prev,
                    faqList: [...prev.faqList, ...response.data],
                    pagination: response.pagination,
                }));
            }
        });
    };

    // Add scroll event listener
    useEffect(() => {
        const handleScroll = () => {
            const container = scrollRef.current;
            if (!container || isLoading) return;

            const { scrollTop, scrollHeight, clientHeight } = container;
            const isBottom = scrollTop + clientHeight >= scrollHeight - 100;

            if (isBottom && state.pagination.currentPage < state.pagination.totalPages) {
                setState((prev) => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        currentPage: prev.pagination.currentPage + 1,
                    },
                }));
            }
        };

        const currentRef = scrollRef.current;
        if (currentRef) {
            currentRef.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (currentRef) {
                currentRef.removeEventListener('scroll', handleScroll);
            }
        };
    }, [state.pagination, isLoading]);

    return (
        <div className="faq_panel">
            <div
                className="card overflow-auto"
                style={{ maxHeight: '537px' }}
                ref={scrollRef}
            >
                <div className="card-body">
                    <div className="accordion px-lg-5 px-3 py-5" id="accordionExample">
                        {state.faqList.length > 0 ? (
                            state.faqList.map((faq) => {
                                const collapseId = `collapse-${faq._id}`;
                                const headingId = `heading-${faq._id}`;
                                return (
                                    <div key={faq._id} className="card">
                                        <div className="card-header" id={headingId}>
                                            <h2 className="mb-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-link collapsed"
                                                    data-toggle="collapse"
                                                    data-target={`#${collapseId}`}
                                                    aria-expanded="false"
                                                    aria-controls={collapseId}
                                                >
                                                    <i className="icon_faq icofont-plus" /> {faq.question}
                                                </button>
                                            </h2>
                                        </div>
                                        <div
                                            id={collapseId}
                                            className="collapse"
                                            aria-labelledby={headingId}
                                            data-parent="#accordionExample"
                                        >
                                            <div className="card-body">
                                                <p>{faq.answer}</p>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <p>No Data Found!</p>
                        )}
                    </div>
                    {isLoading && (
                        <div className="d-flex justify-content-center col-12 mb-5 pb-5">
                            <div className="spinner-border text-secondary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
